import React, { useEffect, useState } from "react";
import { useDeleteCompanyLocation, useGetCompanies, useGetCompanyLocations, useImportLocations } from "../../../../backend/masters";
import Icon from "../../../common/Icon";
import { ACTIONS, EXCEL_FILE_REGEX, FILE_SIZE } from "../../../common/Constants";
import Table, { CellTmpl, DEFAULT_OPTIONS_PAYLOAD, DEFAULT_PAYLOAD, TitleTmpl, reactFormatter } from "../../../common/Table";
import { Button } from "react-bootstrap";
import ConfirmModal from "../../../common/ConfirmModal";
import { useQueryParams } from "raviger";
import CompanyLocationDetails from "./CompanyLocationMappingDetails";
import { useRef } from "react";
import TableFilters from "../../../common/TableFilter";
import { toast } from "react-toastify";
import { API_RESULT, ERROR_MESSAGES } from "../../../../utils/constants";
import PageLoader from "../../../shared/PageLoader";
import MastersLayout from "../MastersLayout";
import { GetMastersBreadcrumb } from "../Master.constants";
import styles from "./Companies.module.css"
import CompanyLocationsImportModal from "./CompanyLocationsImportModal";
import { ResponseModel } from "../../../../models/responseModel";
import { useExportCompanyLocations } from "../../../../backend/exports";
import { downloadFileContent, getValue, preventDefault } from "../../../../utils/common";
import { USER_PRIVILEGES } from "../../UserManagement/Roles/RoleConfiguration";
import TableActions, { ActionButton } from "../../../common/TableActions";
import { download } from "../../../../utils/common";
import BaseImportModal from "../../../common/BaseImportModal";
import { componentTypes } from "../../../common/FormRenderer";
import { validatorTypes } from "@data-driven-forms/react-form-renderer";

function mapLocation(x: any) {
    return {
        id: x.id,
        location_id: x.location_id,
        companyLocationAddress: x.companyLocationAddress,
        locationCode: x.location.code,
        locationName: x.location.name,
       // locationNameID : x.location.id,
        city: x.location.cities,
        state: x.location.cities.state,
        contactPersonName: x.contactPersonName,
        contactPersonMobile: x.contactPersonMobile,
        contactPersonEmail: x.contactPersonEmail,
        address: x.address,
        digitalSignature: x.digitalSignature,
        employerDesignation: x.employerDesignation,
        employerName :x.employerName,
        pfCode : x.pfCode,
        esicCode : x.esicCode,
        registrationCertificateNo : x.registrationCertificateNo,
    }
};

function CompanyLocationMappings() {
    const [breadcrumb] = useState(GetMastersBreadcrumb('Location Mapping'));
    const [query] = useQueryParams();
    const [action, setAction] = useState(ACTIONS.NONE);
    const [parentCompany, setParentCompany] = useState<any>(null);
    const [associate_company, setAssociateCompany] = useState<any>(null);
    const [companyLocation, setCompanyLocation] = useState<any>(null);
    const [data, setData] = useState<any>();
    const [params, setParams] = useState<any>();
    const [filters, setFilters] = useState<any>();
    const filterRef: any = useRef();
    filterRef.current = filters;
    const [payload, setPayload] = useState<any>();
    const { companies: parentCompanies, isFetching: fetchingCompanies } = useGetCompanies({ ...DEFAULT_OPTIONS_PAYLOAD, filters: [{ columnName: 'isParent', value: 'true' }] });
    const { companies: associateCompanies, isFetching: fetchingAssociateCompanies } = useGetCompanies({
        ...DEFAULT_OPTIONS_PAYLOAD,
        filters: [{ columnName: 'isParent', value: 'false' }, { columnName: 'parentCompanyId', value: (parentCompany || {}).value }]
    }, Boolean((parentCompany || {}).value));
    const { locations, total, isFetching, refetch } = useGetCompanyLocations(payload, Boolean(associate_company && payload));
    const { deleteCompanyLocation, deleting } = useDeleteCompanyLocation(({ key, value }: ResponseModel) => {
        if (key === API_RESULT.SUCCESS) {
            toast.success(`Location ${companyLocation.locationName} deleted successfully.`);
            submitCallback();
        } else {
            toast.error(value || ERROR_MESSAGES.ERROR);
        }
    });

    const { exportRecords, exporting } = useExportCompanyLocations((response: any) => {
        downloadFileContent({
            name: 'CompanyLocations.xlsx',
            type: response.headers['content-type'],
            content: response.data
        });
    }, () => {
        toast.error(ERROR_MESSAGES.DEFAULT);
    });

    const buttons: ActionButton[] = [
        {
            label: 'Add New',
            name: 'addNew',
            icon: 'plus',
            disabled: !associate_company,
            privilege: USER_PRIVILEGES.ADD_LOCATION_MAPPING,
            action: () => setAction(ACTIONS.ADD)
        },
        {
            label: 'Export',
            name: 'export',
            icon: 'download',
            disabled: !total,
            privilege: USER_PRIVILEGES.EXPORT_LOCATION_MAPPINGS,
            action: handleExport
        },
        {
            label: 'Import',
            name: 'import',
            disabled: !associate_company,
            icon: 'upload',
            privilege: USER_PRIVILEGES.ADD_LOCATION_MAPPING,
            action: () => setAction(ACTIONS.IMPORT)
        }
    ];

    const filterConfig = [
        {
            label: 'Company',
            name: 'parentCompanyId',
            options: (parentCompanies || []).map((x: any) => {
                return { value: x.id, label: x.name };
            }),
            hideAll: true,
            value: parentCompany
        },
        {
            label: 'Associate Company',
            name: 'associate_company_id',
            options: (associateCompanies || []).map((x: any) => {
                return { value: x.id, label: x.name };
            }),
            hideAll: true,
            value: associate_company
        }
    ]

    function submitCallback() {
        setAction(ACTIONS.NONE);
        setCompanyLocation(null);
        refetch();
    }

    function ActionColumnElements({ cell }: any) {
        const row = cell.getData();
        return (
            <div className="d-flex flex-row align-items-center position-relative h-100">
                <Icon className="mx-2" type="button" name={'pencil'} text={'Edit'} data={row} action={(event: any) => {
                    setCompanyLocation(row);
                    setAction(ACTIONS.EDIT);
                }} />
                {/* <Icon className="mx-2" type="button" name={'trash'} text={'Delete'} data={row} action={(event: any) => {
                    setCompanyLocation(row);
                    setAction(ACTIONS.DELETE);
                }} /> */}
                <Icon className="mx-2" type="button" name={'eye'} text={'View'} data={row} action={(event: any) => {
                    setCompanyLocation(row);
                    setAction(ACTIONS.VIEW);
                }} />
                {
                    row.digitalSignature &&
                    <Icon type="button" name={'download'} text={'View'} data={row} action={() => {
                        download("Signature", row.digitalSignature)
                    }} />
                }
            </div>
        )
    }

    const columns = [
        {
            title: "Name", field: "locationName", widthGrow: 2,
            formatter: reactFormatter(<CellTmpl />),
            titleFormatter: reactFormatter(<TitleTmpl />)
        },
        // {
        //     title: "GUID", field: "locationNameID", widthGrow: 2,
        //     formatter: reactFormatter(<CellTmpl />),
        //     titleFormatter: reactFormatter(<TitleTmpl />)
        // },
        {
            title: "Code", field: "locationCode", width: 120,
            formatter: reactFormatter(<CellTmpl />),
            titleFormatter: reactFormatter(<TitleTmpl />)
        },
        {
            title: "Contact Person", field: "contactPersonName",
            formatter: reactFormatter(<CellTmpl />),
            titleFormatter: reactFormatter(<TitleTmpl />)
        },
        {
            title: "Contact No.", field: "contactPersonMobile", minWidth: 140,
            formatter: reactFormatter(<CellTmpl />),
            titleFormatter: reactFormatter(<TitleTmpl />)
        },
        {
            title: "Email Address", field: "contactPersonEmail", minWidth: 140,
            formatter: reactFormatter(<CellTmpl />),
            titleFormatter: reactFormatter(<TitleTmpl />)
        },
        
        {
            title: "Employer Name", field: "employerName", minWidth: 140,
            formatter: reactFormatter(<CellTmpl />),
            titleFormatter: reactFormatter(<TitleTmpl />)
        },
        
        {
            title: "Employer Designation", field: "employerDesignation", minWidth: 140,
            formatter: reactFormatter(<CellTmpl />),
            titleFormatter: reactFormatter(<TitleTmpl />)
        },
        {
            title: "PF Code", field: "pfCode", minWidth: 140,
            formatter: reactFormatter(<CellTmpl />),
            titleFormatter: reactFormatter(<TitleTmpl />)
        },
        
        {
            title: "ESIC Code", field: "esicCode", minWidth: 140,
            formatter: reactFormatter(<CellTmpl />),
            titleFormatter: reactFormatter(<TitleTmpl />)
        },
        {
            title: "Reg.Certificate No", field: "registrationCertificateNo", minWidth: 140,
            formatter: reactFormatter(<CellTmpl />),
            titleFormatter: reactFormatter(<TitleTmpl />)
        },
        {
            title: "Actions", hozAlign: "center", width: 160,
            headerSort: false, formatter: reactFormatter(<ActionColumnElements />)
        }
    ];

    const [tableConfig] = useState({
        paginationMode: 'remote',
        ajaxRequestFunc,
        columns,
        rowHeight: 54,
        selectable: false,
        paginate: true,
        initialSort: [{ column: 'locationName', dir: 'asc' }]
    });

    function formatApiResponse(params: any, list: any[], totalRecords: number) {
        const { pagination } = params || {};
        const { per, page } = pagination || {};
        const tdata = {
            data: list.map(x => {
                return mapLocation(x)
            }),
            total: totalRecords,
            last_page: Math.ceil(totalRecords / (per || 1)) || 1,
            page: page || 1
        };
        setData(tdata);
        return tdata;
    }

    function ajaxRequestFunc(url: any, config: any, params: any) {
        const { field, dir } = (params.sort || [])[0] || {};
        const _params = {
            pagination: {
                per: params.size,
                page: params.page
            },
            sort: {
                columnName: field || 'locationName',
                order: dir || 'asc'
            }
        };
        setParams(_params);
        setPayload({ ...DEFAULT_PAYLOAD, ...filterRef.current, ..._params });
        return Promise.resolve(formatApiResponse(params, locations, total));
    }

    function deleteCompanyMaster() {
        deleteCompanyLocation(companyLocation.id);
    }
    function onFilterChange(e: any) {
        setFilters(e);
    }

    function handlePageNav(_pagination: any) {
        const _params = { ...params };
        _params.pagination = _pagination;
        setParams({ ..._params });
        setPayload({ ...payload, ..._params })
    }

    function handleExport() {
        if (total > 0) {
            exportRecords({ ...payload, pagination: null });
        }
    }

    useEffect(() => {
        if (query && (query.parentCompany || query.associate_company)) {
            setParentCompany({ value: query.parentCompany });
            setAssociateCompany({ value: query.associate_company });
        }
    }, [query]);

    useEffect(() => {
        if (filters) {
            const { filters: _filters, search } = filters;
            setData(formatApiResponse(params, [], 0));
            const _associate_company_id = (_filters.find((x: any) => x.columnName === 'associate_company_id') || {}).value;
            const _parentCompanyId = (_filters.find((x: any) => x.columnName === 'parentCompanyId') || {}).value;
            if (_parentCompanyId) {
                const _parentCompany = parentCompanies.find((x: any) => x.id === _parentCompanyId);
                setParentCompany({ value: _parentCompany.id, label: _parentCompany.name, code: _parentCompany.code });
                if ((parentCompany || {}).value !== _parentCompanyId) {
                    setAssociateCompany(null);
                    setPayload(null);
                    return;
                }
            }
            if (_associate_company_id) {
                const _associate_company = associateCompanies.find((x: any) => x.id === _associate_company_id);
                if (_associate_company) {
                    setAssociateCompany({ value: _associate_company.id, label: _associate_company.name, code: _associate_company.code });
                    const _x = {
                        filters: [
                            { columnName: 'company_id', value: _associate_company_id }
                        ],
                        search
                    }
                    setPayload({ ...DEFAULT_PAYLOAD, ...params, ..._x });
                    return;
                }
            }
            setPayload({ ...payload, search });
        }
    }, [filters]);

    useEffect(() => {
        if (!isFetching && payload) {
            setData(formatApiResponse(params, locations, total));
        }
    }, [isFetching]);

    useEffect(() => {
        if (!fetchingCompanies && parentCompanies) {
            const _parentCompany = (parentCompanies || [])[0] || {};
            setParentCompany({ value: _parentCompany.id, label: _parentCompany.name, code: _parentCompany.code });
        }
    }, [fetchingCompanies]);

    useEffect(() => {
        if (!fetchingAssociateCompanies && associateCompanies) {
            const _associate_company = (associateCompanies || [])[0];
            if (_associate_company) {
                setAssociateCompany({ value: _associate_company.id, label: _associate_company.name, code: _associate_company.code });
                const { search } = filterRef.current || { search: '' };
                setFilters({
                    filters: [
                        { columnName: 'parentCompanyId', value: (parentCompany || {}).value },
                        { columnName: 'associate_company_id', value: _associate_company.id }
                    ], search
                });
            }
        }
    }, [fetchingAssociateCompanies]);

    const importSchema = {
        fields: [
            {
                component: componentTypes.PLAIN_TEXT,
                label: 'Company',
                content: getValue(parentCompany, 'label'),
                name: 'company'
            },
            {
                component: componentTypes.PLAIN_TEXT,
                label: 'Associate Company',
                content: getValue(associate_company, 'label'),
                name: 'associate_company'
            },
            {
                component: componentTypes.FILE_UPLOAD,
                label: 'Upload File',
                name: 'file',
                type: 'file',
                validate: [
                    { type: validatorTypes.REQUIRED },
                    { type: 'file-type', regex: EXCEL_FILE_REGEX },
                    { type: 'file-size', maxSize: 10 * FILE_SIZE.MB }
                ],
                description: <a href="/" onClick={downloadSample}>Dowload Sample Locations</a>
            },
        ],
    };

    function downloadSample(e: any) {
        preventDefault(e);
        //download('Sample Locations.xlsx', 'https://mafoi.s3.ap-south-1.amazonaws.com/bulkuploadtemplates/LocationBulkUploadTemplate.xlsx ')
        download('Sample Locations.xlsx', 'https://mafoi.s3.ap-south-1.amazonaws.com/bulkuploadtemplates/LocationBulkUploadTemplateNEw.xlsx ')
    }

    return (
        <>
            <MastersLayout title="Location Mapping" breadcrumbs={breadcrumb}>
                <div className="d-flex flex-column mx-0">
                    <div className="card shadow d-flex flex-row justify-content-center m-3 p-3">
                        <div className="col-12">
                            <div className="d-flex justify-content-between align-items-end">
                                <TableFilters filterConfig={filterConfig} search={true} onFilterChange={onFilterChange}
                                    placeholder={"Search for Location Code/Name/Contact"} />
                                <TableActions buttons={buttons} />
                            </div>
                        </div>
                    </div>
                    <Table data={data} options={tableConfig} isLoading={isFetching} onPageNav={handlePageNav} />
                </div>
            </MastersLayout>

            {
                [ACTIONS.ADD, ACTIONS.EDIT, ACTIONS.VIEW].includes(action) &&
                <CompanyLocationDetails action={action} parentCompany={parentCompany} associate_company={associate_company}
                    data={companyLocation}
                    onClose={() => {
                        setAction(ACTIONS.NONE);
                        setCompanyLocation(null);
                    }} onSubmit={submitCallback} />
            }
            {
                action === ACTIONS.DELETE &&
                <ConfirmModal title={'Delete Company Location'} onSubmit={deleteCompanyMaster} onClose={() => setAction(ACTIONS.NONE)}>
                    <div className="text-center mb-4">Are you sure you want to delete the Company Location, <strong>{(companyLocation || {}).locationName}</strong> ?</div>
                </ConfirmModal>
            }
            {/* {
                action === ACTIONS.IMPORT &&
                <CompanyLocationsImportModal company={parentCompany} associate_company={associate_company}
                    onSubmit={refetch}
                    onClose={() => setAction(ACTIONS.NONE)} />
            } */}
            {
                action === ACTIONS.IMPORT && <BaseImportModal onClose={() => setAction(ACTIONS.NONE)} importSchema={importSchema} importFunction={useImportLocations} title="Import Company Locations" />
            }
            {deleting && <PageLoader message={'Deleting Location...'} />}
            {exporting && <PageLoader message={'Preparing data...'} />}
        </>
    )
}

export default CompanyLocationMappings;
